.table {
  width: 100%;
  table-layout: fixed;
}

.table:not([data-mobile-active]) th:first-child {
  width: 28%;
}

.table:not([data-mobile-active]) .compact {
  width: 10ch;
}

.table[data-mobile-active] .compact {
  width: auto;
}

.name {
  white-space: normal;
  overflow-wrap: anywhere;
}

.compact {
  white-space: nowrap;
}

.permission {
  max-width: 100%;
  min-width: 0;
}

.permissionText {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
